import React from "react";
import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <Seo title="Privacy Policy" description="How Rooted in Amador collects and uses your information." path="/privacy" />
      <div className="text-xs tracking-wider-2 uppercase text-sage mb-3">Legal</div>
      <h1 className="font-display text-5xl text-darkRoast mb-12">Privacy Policy</h1>
      <div className="prose prose-stone max-w-none text-earth space-y-8 leading-relaxed">

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">What we collect</h2>
          <p>When you place an order or create an account, we collect your name, email address, shipping address, and payment information. Payment details are processed securely by Stripe and are never stored on our servers. If you sign in with Google, we receive your name and email from Google.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">How we use it</h2>
          <p>We use your information solely to fulfill orders, send order confirmations, and respond to your inquiries. We do not sell, rent, or share your personal information with third parties for marketing purposes.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Cookies</h2>
          <p>We use cookies to keep you signed in and to remember your shopping cart. We do not use tracking cookies or third-party advertising cookies.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Your rights (California residents)</h2>
          <p>Under the California Consumer Privacy Act (CCPA), you have the right to know what personal information we collect, request deletion of your data, and opt out of any sale of your information (we do not sell your information). To exercise these rights, email us at <a href="mailto:hello@rootedinamador.com" className="text-darkRoast underline hover:text-sage">hello@rootedinamador.com</a>.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Data retention</h2>
          <p>We retain order records for up to 7 years as required for tax and accounting purposes. Account information is retained until you request deletion.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Contact</h2>
          <p>Questions about this policy? Email <a href="mailto:hello@rootedinamador.com" className="text-darkRoast underline hover:text-sage">hello@rootedinamador.com</a>.</p>
          <p className="text-sm text-earth/70 mt-4">Last updated: June 2026</p>
        </section>

      </div>
    </div>
  );
}
